if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleClick);
      });
    }

    disconnectedCallback() {
      this.buttons.forEach((button) => {
        button.removeEventListener('click', this.handleClick);
      });

      document.documentElement.classList.remove('overflow-hidden');
    }

    get isOpen() {
      return this.hasAttribute('open');
    }

    get triggerButtons() {
      if (!this.id) return [];

      return [...document.querySelectorAll(`[data-modal-trigger="${this.id}"]`)];
    }

    get buttons() {
      return [...this.querySelectorAll('[data-modal-close]'), ...this.triggerButtons];
    }

    handleClick(event) {
      event.preventDefault();

      const isCloseButton = event.currentTarget.hasAttribute('data-modal-close');

      this.toggle(!isCloseButton);
    }

    toggle(force) {
      const shouldOpen = force ?? !this.isOpen;

      this.toggleAttribute('open', shouldOpen);
      this.toggleAttribute('inert', !shouldOpen);

      this.triggerButtons.forEach((button) => {
        button.setAttribute('aria-expanded', String(shouldOpen));
      });

      document.documentElement.classList.toggle('overflow-hidden', shouldOpen);
    }
  }

  customElements.define('modal-dialog', ModalDialog);
}